// Display top red banner alert with white text
export function showTopBannerError(message) {
  if (!message) return;

  const existingAlert = document.getElementById("onboarding-error-alert");
  if (existingAlert) existingAlert.remove();

  const alertDiv = document.createElement("div");
  alertDiv.id = "onboarding-error-alert";
  alertDiv.className = "alert alert-dismissible fade show";
  alertDiv.setAttribute("role", "alert");
  alertDiv.style.position = "fixed";
  alertDiv.style.left = "0";
  alertDiv.style.width = "100%";
  alertDiv.style.zIndex = "10000";
  alertDiv.style.borderRadius = "0";
  alertDiv.style.margin = "0";
  alertDiv.style.boxShadow = "0 2px 10px rgba(0,0,0,0.15)";
  alertDiv.style.backgroundColor = "#e62e2e";
  alertDiv.style.color = "#ffffff";
  alertDiv.style.border = "none";

  if (typeof window !== "undefined" && window.innerWidth <= 768) {
    alertDiv.style.bottom = "0";
    alertDiv.style.top = "auto";
  } else {
    alertDiv.style.top = "0";
    alertDiv.style.bottom = "auto";
  }

  const textDiv = document.createElement("div");
  textDiv.className = "container-fluid text-center fw-bold";
  textDiv.textContent = message;
  alertDiv.appendChild(textDiv);

  const closeBtn = document.createElement("button");
  closeBtn.type = "button";
  closeBtn.className = "btn-close btn-close-white";
  closeBtn.setAttribute("data-bs-dismiss", "alert");
  closeBtn.setAttribute("aria-label", "Close");
  closeBtn.style.top = "50%";
  closeBtn.style.transform = "translateY(-50%)";
  closeBtn.onclick = () => alertDiv.remove();
  alertDiv.appendChild(closeBtn);

  document.body.insertBefore(alertDiv, document.body.firstChild);

  setTimeout(() => {
    if (alertDiv && alertDiv.parentNode) {
      alertDiv.style.transition = "opacity 0.5s ease";
      alertDiv.style.opacity = "0";
      setTimeout(() => {
        if (alertDiv.parentNode) alertDiv.remove();
      }, 500);
    }
  }, 6000);
}

// Check whether an input or group is currently active, connected to DOM and visible
export function isFieldActiveAndVisible(input) {
  if (!input || typeof input !== "object" || Array.isArray(input)) return false;

  if (typeof input.isConnected === "boolean" && !input.isConnected) return false;
  if (input.disabled) return false;
  if (input.closest && input.closest(".d-none, [hidden]")) return false;

  if (typeof window !== "undefined" && window.getComputedStyle) {
    try {
      const style = window.getComputedStyle(input);
      if (style.display === "none" || style.visibility === "hidden") return false;
    } catch (_) {}
  }

  return true;
}

if (typeof window !== "undefined") {
  window.showTopBannerError = showTopBannerError;
  window.isFieldActiveAndVisible = isFieldActiveAndVisible;
}

